class HeaderManager {
  constructor() {
    this.threshold = 10;
    this.header = document.querySelector('.header');
    this.header_flexbox = document.querySelector('.header_flexbox');

    this.checkHeaderHeight = this.checkHeaderHeight.bind(this);

    document.addEventListener('DOMContentLoaded', () => {
      this.checkHeaderHeight();
      document.addEventListener('scroll', this.checkHeaderHeight);
      window.addEventListener('resize', this.checkHeaderHeight);
    });
  }

  checkHeaderHeight() {
    const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    const windowWidth = window.innerWidth;

    if (scrollPosition < 10) {
      this.header_flexbox.style.padding = '0px 0px';
      this.header.style.top = '-100px';
    }

    if (scrollPosition > 10) {
      if (scrollPosition < this.threshold || scrollPosition > this.threshold) {
        this.header_flexbox.style.padding = '10px 0px';
        this.header.style.top = '0px';
      }
    }
  }
}

// Initialiseer de class
new HeaderManager();
